export const membersTypes = {
    set: 'MEMBERS/SET_MEMBERS',
    filter: 'MEMBERS/FILTER_MEMBERS',
    setFirst: 'MEMBERS/SET_MEMBERS_FIRST',
    remove: 'MEMBERS/REMOVE_MEMBERS',
    page: 'MEMBERS/CHANGE_PAGE'
}
